import { useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import { IObjectWithId } from 'interfaces/common';

import { getValuesExceptId } from 'helpers/objects';

import { IPeriodsTableRow } from '../constants/periods';

export const useHandleTotalCalculation = (fieldName: string) => {
  const { setValue } = useFormContext();

  const isFirstMount = useRef(true);

  const handleTotalCalculated = (totalValues: IObjectWithId) => {
    if (isFirstMount.current) {
      isFirstMount.current = false;

      return;
    }
    setValue(fieldName, getValuesExceptId(totalValues));
  };

  return handleTotalCalculated;
};

export const useHandlePeriodTotalCalculation = (fieldName: string) => {
  const { setValue } = useFormContext();

  const isFirstMount = useRef(true);

  const handleTotalCalculated = (totalValues: IPeriodsTableRow) => {
    if (isFirstMount.current) {
      isFirstMount.current = false;

      return;
    }
    setValue(fieldName, totalValues);
  };

  return handleTotalCalculated;
};
